import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonButton from '../components/atom/CommonButton';
import useNotify from '../hooks/useNotify';

const TwoFactorLoginModal = ({ MODAL_TYPE, showModal, handleValidation }) => {
    const [verificationCode, setVerificationCode] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    const { t } = useTranslation();
    const { notifyError } = useNotify();

    const handleClose = () => {
        showModal(MODAL_TYPE.NONE);
    };

    const handleContinue = async () => {
        if (verificationCode.length !== 6 || isVerifying) {
            return;
        }

        setIsVerifying(true);
        try {
            await handleValidation(verificationCode);
            handleClose();
        } catch (error) {
            console.error('Error verifying 2FA code:', error);
            notifyError(t('users.invalidTwoFactorCode'));
            setVerificationCode('');
        } finally {
            setIsVerifying(false);
        }
    };

    return (
        <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>{t('users.twoFactorVerification')}</DialogTitle>
            <DialogContent>
                <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        {t('users.enterTwoFactorCodeDescription')}
                    </Typography>

                    <TextField
                        fullWidth
                        placeholder="000000"
                        variant="outlined"
                        autoFocus
                        value={verificationCode}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, '');
                            if (val.length <= 6) {
                                setVerificationCode(val);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && verificationCode.length === 6) {
                                handleContinue();
                            }
                        }}
                        slotProps={{
                            htmlInput: {
                                maxLength: 6,
                                style: {
                                    textAlign: 'center',
                                    fontSize: '2rem',
                                    letterSpacing: '0.5rem',
                                    fontWeight: 'bold',
                                },
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <CommonButton
                    label={t('common.cancel')}
                    buttonType="secondary"
                    onClick={handleClose}
                />
                <CommonButton
                    label={t('common.continue')}
                    buttonType="primary"
                    disabled={verificationCode.length !== 6 || isVerifying}
                    onClick={handleContinue}
                />
            </DialogActions>
        </Dialog>
    );
};

export default TwoFactorLoginModal;
